var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPuzzle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.75,
    height: 33.035,
    viewBox: "0 0 32.75 33.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "puzzle",
    transform: "translate(0 7.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M5.614,12.505a.757.757,0,0,1,.06.717,1.27,1.27,0,1,0,2.328,0,.757.757,0,0,1,.694-1.06h3.467V9.622h-.054a2.784,2.784,0,1,1,0-5.568h.054V0H2.784A2.787,2.787,0,0,0,0,2.784v9.379H4.98A.757.757,0,0,1,5.614,12.505Z",
    transform: "translate(0 0)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M226.983,0H217.6V4.981a.757.757,0,0,1-1.06.694,1.27,1.27,0,1,0,0,2.329.757.757,0,0,1,1.06.694v3.466h2.541c0-.018,0-.036,0-.054a2.784,2.784,0,0,1,5.568,0c0,.018,0,.036,0,.054h4.055V2.784A2.787,2.787,0,0,0,226.983,0Z",
    transform: "translate(-166.234 -114.578) rotate(30)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M15,276.325a1.27,1.27,0,0,0-1.778-1.164.757.757,0,0,1-1.06-.694V271H9.622c0,.018,0,.036,0,.054a2.784,2.784,0,1,1-5.568,0c0-.018,0-.036,0-.054H0v9.379a2.787,2.787,0,0,0,2.784,2.784h9.379v-4.98a.757.757,0,0,1,1.06-.694A1.27,1.27,0,0,0,15,276.325Z",
    transform: "translate(0 -257.323)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M277.549,217.262a.757.757,0,0,1-.06-.718,1.27,1.27,0,1,0-2.329,0,.757.757,0,0,1-.694,1.06H271v2.541h.054a2.784,2.784,0,0,1,0,5.568H271v4.055h9.379a2.787,2.787,0,0,0,2.784-2.784V217.6h-4.981a.757.757,0,0,1-.634-.342Z",
    transform: "translate(-257.323 -203.927)",
    fill: "#4e3057"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default __webpack_public_path__ + "static/media/puzzle.6d948568d94bc0408e84128465a8d99e.svg";
export { ForwardRef as ReactComponent };